import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "../../../../../reducers/initialState";

export default function reducer(state = initialState.currentOffer.feesData, action) {
  const feesDataInitialData = initialState.currentOffer.feesData;
  switch (action.type) {
    case actionTypes.LOAD_SCHEMA_EXCHANGE_RATE_FAILED: {
      return {
        ...state,
        schemaExchangeRatesLoaded: false
      };
    }

    case actionTypes.LOAD_SCHEMA_EXCHANGE_RATE_SUCCESS: {
      return {
        ...state,
        schemaExchangeRates: action.payload.schemaExchangeRates.exchangeRates,
        schemaExchangeRatesLoaded: true
      };
    }

    case actionTypes.LOAD_OFFER_FEES_SUCCESS: {
      return {
        ...state,
        fees: action.payload.fees,
        feesLoaded: true
      };
    }

    case actionTypes.LOAD_OFFER_FEES_FAILED: {
      return {
        ...state,
        feesLoaded: false
      };
    }

    case actionTypes.UPDATE_OFFER_FEES_STARTED: {
      return {
        ...state,
        saving: true,
        editable: false
      };
    }

    case actionTypes.LOAD_OFFER_FEES_NEGOTIATION_DATA_SUCCEEDED: {
      return {
        ...state,
        schemaIsEligibleForNegotiation: action.payload.schemaIsEligibleForNegotiation,
        negotiationStatus: action.payload.negotiationStatus,
        negotiationType: action.payload.negotiationType,
        feeCatalogLoading: false,
        feeCatalogLoaded: true
      };
    }

    case actionTypes.UPDATE_OFFER_FEES_CATALOG_FAILED: {
      return {
        ...state,
        saving: false,
        editable: true
      };
    }

    case eventTypes.OFFER_FEES_INVALIDATED: {
      return feesDataInitialData;
    }

    case actionTypes.CHANGE_EDITABLE_PROPERTY: {
      return {
        ...state,
        editable: action.payload.value
      };
    }

    case actionTypes.CANCEL_OFFER_FEES_CHANGES: {
      return {
        ...state,
        editable: false,
        saving: false
      };
    }

    case actionTypes.UPDATE_OFFER_FEE_APPROVAL1_SUCCEDED: {
      let idx = 0;
      let idxFin = 0;
      let localFeeData = { ...state };
      localFeeData.fees.forEach(fee => {
        if (fee.feeId === action.payload.schemaDetailId) idxFin = idx;

        idx++;
      });
      return {
        ...state,
        fees: state.fees.map((fee, i) =>
          i === idxFin
            ? {
                ...fee,
                approvalStatus: action.payload.approvalStatus,
                firstApprovalUserName: action.payload.userPersonName
              }
            : fee
        )
      };
    }

    case actionTypes.UPDATE_OFFER_FEE_APPROVAL2_SUCCEDED: {
      let idx = 0;
      let idxFin = 0;
      let localFeeData = { ...state };
      localFeeData.fees.forEach(fee => {
        if (fee.feeId === action.payload.schemaDetailId) idxFin = idx;

        idx++;
      });
      return {
        ...state,
        fees: state.fees.map((fee, i) =>
          i === idxFin ? { ...fee, approvalStatus: action.payload.approvalStatus } : fee
        )
      };
    }

    default:
      return state;
  }
}
